const API_ROOT = '/api/startups'

export const getStartupUrl = ( id ) => `${API_ROOT}/startup/${id}`

export const getUserStartupUrl = () => `${API_ROOT}/user`

export const getStartupData = () => `${API_ROOT}/startups/data`
